import { render, staticRenderFns } from "./youtubeplayer3.vue?vue&type=template&id=12aa4b07&scoped=true"
import script from "./youtubeplayer3.vue?vue&type=script&lang=js"
export * from "./youtubeplayer3.vue?vue&type=script&lang=js"
import style0 from "./youtubeplayer3.vue?vue&type=style&index=0&id=12aa4b07&lang=scss&scoped=true"
import style1 from "./youtubeplayer3.vue?vue&type=style&index=1&id=12aa4b07&lang=scss"


/* normalize component */
import normalizer from "!../globalsearch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aa4b07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/globalsearch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12aa4b07')) {
      api.createRecord('12aa4b07', component.options)
    } else {
      api.reload('12aa4b07', component.options)
    }
    module.hot.accept("./youtubeplayer3.vue?vue&type=template&id=12aa4b07&scoped=true", function () {
      api.rerender('12aa4b07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "globalComponents/youtubeplayer3.vue"
export default component.exports